import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import {RoamingCommunityModel} from "../../models/roaming-community.model";
import {Location} from '@angular/common';
import {Router} from "@angular/router";
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Output} from "@angular/core";
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-create-roaming-communities',
  templateUrl: './create-roaming-communities.component.html',
})
export class CreateRoamingCommunitiesComponent implements OnInit {

  public roamingCommunityModel: RoamingCommunityModel;
  public noValid: boolean = false;
  public nameExist;
  public disableName = false;
  public disableSaveButton = false;
  public duplicatesExist = false;
  public duplicateError = false;
  public searchText = '';
  public showSearch = false;
  public visibleAnimate = false;
  public hasError = false;
  public patternError = false;
  public protocolVersionExists = false;

  public protocolVersions: string[] = ['1.0', '1.1']

  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  public errorClass = ["ng-pristine", "ng-invalid", "ng-touched"];

  @Input() validationType;
  @Input() dataType;
  @ViewChild('validate', { static: true }) validate: NgForm;

  constructor(private router: Router,
              private _location: Location,
              private http: HttpClient) {
    this.roamingCommunityModel = new RoamingCommunityModel();
  }

  public selectedProtocolVersion(value:any): void {
      this.roamingCommunityModel.protocolVersion = value.split(",", 1)[0];
      this.protocolVersionExists = true;
    }

  // Validation fields
  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  validateName(name, nameElement) {
    this.nameExist = false;
    nameElement.classList.remove(...this.class);

    if(name.trim().length == 0){
      this.disableName = true;
      nameElement.classList.remove(this.class);
      nameElement.classList.add(this.errorClass);
    } else {
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.EXISTS_RC_NAME;
      name = name.replace(/\s\s+/g, ' ');
      name = name.trim();
      var body = {
        "name": name,
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.nameExist = data.response;
          }
        );
      this.disableName = false;
      nameElement.classList.add(...this.class);
    }
  }

  saveRoamingCommunity() {
    this.roamingCommunityModel.name = this.roamingCommunityModel.name.trim();
    var body: any = JSON.parse(JSON.stringify(this.roamingCommunityModel));
    var url = ApiEndpoints.CREATE_ROAMING_COMMUNITY;
    const headers = new HttpHeaders({'Content-Type':  'application/json'});
    let options =  {headers: headers};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.router.navigate(['/all-roaming-community']);
        }
      );
  }

  backClicked() {
    this._location.back();
  }

  ngOnInit() {
  }

}
